import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWith } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        loginWith(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.user?.onboarded ? "/dashboard" : "/onboarding", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, loginWith]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background tcc-dots">
      <div className="text-center">
        <div className="h-12 w-12 mx-auto rounded-full border-4 border-primary/30 border-t-primary animate-spin" />
        <p className="mt-4 text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
}
